import React, { useContext } from 'react'
import MyImage from '@shared/components/myImage'
import styles from '@shared/components/Advertisement/Advertise.module.scss'
import partner1 from '@assets/images/Advertisement/partner1.png'
import partner2 from '@assets/images/Advertisement/partner2.png'
import partner3 from '@assets/images/Advertisement/partner3.png'
import betting1 from "@assets/images/Advertisement/darkModeImages/betting1.png"
import betting2 from "@assets/images/Advertisement/darkModeImages/betting2.png"
import betting3 from "@assets/images/Advertisement/darkModeImages/betting3.png"
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const BettingPartner = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  return (
    <div className="text-center px-6 pb-4 my-3">
      <h2
        className={`h2  sm:py-0 font-bold ${styles.bettingH1}`}
        style={{
          padding: '30px'
        }}>
        For Betting Partners
      </h2>
      <div
        className={`d-none d-sm-flex flex-column align-items-center justify-content-around px-6 py-6 ${styles.bettingContainer}`}
        style={{
          marginLeft: '50px',
          marginRight: '50px',
          borderRadius: '16px'
        }}>
        <div className="d-flex flex-wrap justify-content-center  pt-4 mx-3 gap-5 w-100">
          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting1 : partner1} alt="Partner 1" width={384} height={350} className="w-75" />

          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting2 : partner2} alt="Partner 2" width={272} height={350} className="w-75" />

          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting3 : partner3} alt="Partner 3" width={384} height={350} className="w-75" />
        </div>
        <div
          className={` w-100 d-flex flex-wrap justify-content-evenly text-xl  p-4 ${styles.bettingTextBox}`}
          style={{
            height: '97px',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            fontSize: '24px',
            fontWeight: '600'
          }}>
          <span className="rounded-lg text-center ">Sponsored Tags</span>
          <span className="rounded-lg text-center py-2 px-4">App Banners</span>
          <span className="rounded-lg text-center py-2 px-4">Social Media Posts</span>
        </div>
      </div>

      <div className="d-flex flex-column gap-3 d-sm-none mx-4">
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center  pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting1 : partner1} loadOnScroll alt="Partner 1" className="w-75" />
          </div>
          <div className={`text-center py-4 px-4 ${styles.lowerContainer}`}>Sponsored Tags</div>
        </div>
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting2 : partner2} loadOnScroll alt="Partner 2" className="w-75" />
          </div>
          <div className={` text-center py-4 px-4 ${styles.lowerContainer}`}>App Banners</div>
        </div>
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? betting3 : partner3} loadOnScroll alt="Partner 3" className="w-75" />
          </div>
          <div className={`text-center py-4 px-4 ${styles.lowerContainer}`}>Social Media Posts</div>
        </div>
      </div>
    </div>
  )
}
export default BettingPartner
